import { TRoutes } from '~/routes/const'
import { routeNames } from '../const'

export default [
    {
        path: routeNames.giftCardCreate,
        component: () => import('../../pages/giftCardManagement/giftCardCreate'),
        meta: { title: '新增/编辑卡券', hideInMenu: true }
    },
    {
        path: routeNames.giftCardList,
        component: () => import('../../pages/giftCardManagement/giftCardList'),
        meta: { title: '卡券管理' }
    },
    {
        path: routeNames.activationInstructions,
        component: () => import('../../pages/giftCardManagement/activationInstructions'),
        meta: { title: '卡券激活说明' }
    },
    {
        path: routeNames.cardNumberManagement,
        component: () => import('../../pages/giftCardManagement/cardNumberManagement'),
        meta: { title: '卡号管理' }
    }
] as TRoutes[]
